import { render } from "./ComboMarca.vue?vue&type=template&id=3799fb12&ts=true"
import script from "./ComboMarca.vue?vue&type=script&lang=ts"
export * from "./ComboMarca.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\OnSeller\\FrontEnd\\Admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__